import { GlobalJourneyContext } from "../../../../context/global-journey-context";
import { getRoleWithYear } from "apps/journeys/utils/helpers";
import { JourneysContext } from "apps/journeys/context/journeys-context";
import { useContext } from "react";
import { PropTypes } from "base/react-libs";
import { Button } from "@evertrue/et-components";
import ContactTimezoneIndicator from "apps/contact/components/contact-timezone-indicator";
import EverTrue from "app";
import Avatar from "components/elements/avatar";

const TaskRowDetailsContactCard = ({ contact, avatarSize = 40, padding = 8, householdCard = false }) => {
  const { setGlobalJourney } = useContext(GlobalJourneyContext);

  const { selectedJourney } = useContext(JourneysContext);

  if (!contact && !Object.keys(contact).length) return null;

  const { contact_attributes = {}, profile_image = {} } = contact;
  const avatarUrl = profile_image ? profile_image.url : null;

  return (
    <div
      data-testid="journeys--contact-card"
      className="journeys--contact-card--container"
      style={{ padding: padding }}
    >
      <Avatar url={avatarUrl} name={contact_attributes.name_full} width={avatarSize} />
      <div className="journeys--contact-card--content fs-exclude-data">
        <div className="journeys--contact-card-main">
          <Button
            className="journeys-contact-card-name"
            type="simple"
            onClick={() => {
              setGlobalJourney(selectedJourney);
              EverTrue.Navigator(`/contact/${contact.id}`, true);
            }}
          >
            {contact_attributes.name_full}
          </Button>
          <ContactTimezoneIndicator contact={contact} />
        </div>
        {householdCard ? (
          <>
            <div>Household Member</div>
            <div>Household</div>
          </>
        ) : (
          <div>{getRoleWithYear(contact)}</div>
        )}
      </div>
    </div>
  );
};

TaskRowDetailsContactCard.propTypes = {
  contact: PropTypes.object,
  avatarSize: PropTypes.number,
  padding: PropTypes.number,
  householdCard: PropTypes.bool,
};

export default TaskRowDetailsContactCard;
